import axios from "axios";
import { ILegalEntity } from "../../types";

export const getLegalEntities = async (): Promise<ILegalEntity[]> => {
    const response = await axios.get('/booking/instool/legal-entities');
    return response.data;
};

export default getLegalEntities;
